export const formatStringToArray = (value: string) =>
  value
    .split(",")
    .map((id) => id.trim())
    .filter((id) => id.length > 0);

export const fromArrayToConcatenatedString = (
  value: string | string[] | undefined,
) =>
  Array.isArray(value)
    ? value.filter((item) => item.trim().length > 0).join(", ")
    : value || "";
